import React, { useState } from 'react';
import styles from './CharcodePill.module.css';
import CharcodeTooltip from "./CharcodeTooltip.js";

/*
    CHARCODE PILL
        A pill/badge component that displays a charcode ID and shows a tooltip on hover
        
        Props:
            charcodeId: string, the charcode ID to display (e.g., "CHA-002428")
            bagInfo: object, optional bag information for the tooltip
            size: string, optional size variant ("small", "medium", "large")
*/
const CharcodePill = (props) => {
    const [displayTip, setDisplayTip] = useState(false);
    const [position, setPosition] = useState({ x: 0, y: 0 });

    const showTooltip = (e) => {
        setDisplayTip(true);
        setPosition({ x: e.clientX, y: e.clientY });
    };

    const sizeClass = props.size ? styles[props.size] : '';
    
    return (
        <div 
            className={`${styles.charcodePill} ${sizeClass}`} 
            onMouseEnter={showTooltip} 
            onMouseLeave={() => setDisplayTip(false)}
        > 
            <div className={styles.text}>#{props.charcodeId}</div>
            {displayTip && (
                <CharcodeTooltip 
                    displayTip={displayTip} 
                    position={position} 
                    charcodeId={props.charcodeId}
                    bagInfo={props.bagInfo}
                />
            )}
        </div>
    );
};

CharcodePill.defaultProps = {
    charcodeId: "CHA-000000",
    size: "medium"
};

export default CharcodePill;


